export default "__VITE_ASSET__CB8R2SqG__"